// extracted by mini-css-extract-plugin
module.exports = {"Links":"Links-3__oY","ProfileItem":"ProfileItem-3Nqy9","BellIcon":"BellIcon-23lAN","BellIconTransparent":"BellIconTransparent-PLbVS"};